var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shopping-store",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.501,
    height: 35.5,
    viewBox: "0 0 35.501 35.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_65341",
    "data-name": "Path 65341",
    d: "M8.331,24.124a.555.555,0,0,0-.555.555v7.939a.555.555,0,0,0,.555.555H21.267a.555.555,0,0,0,.555-.555V24.679a.555.555,0,0,0-.555-.555Zm12.382,7.939H8.885V25.233H20.712Z",
    transform: "translate(-2.025 -6.282)",
    fill: "#06233d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65342",
    "data-name": "Path 65342",
    d: "M3.545,14.75A3.907,3.907,0,0,0,7.267,12.91a3.988,3.988,0,0,0,7,.152,4.116,4.116,0,0,0,.558.75,4.024,4.024,0,0,0,5.843,0,4.116,4.116,0,0,0,.558-.75,3.994,3.994,0,0,0,7-.152A3.929,3.929,0,0,0,35.363,9.8L33.5,2.947V.555A.555.555,0,0,0,32.949,0H2.55A.555.555,0,0,0,2,.555v2.4L.139,9.806A3.934,3.934,0,0,0,3.545,14.75Zm7.274-.791A2.895,2.895,0,0,1,7.961,10.6L9.1,3.577h5.024l-.393,7.248h0l-.021.393a2.9,2.9,0,0,1-2.893,2.742Zm9.047-.91a2.915,2.915,0,0,1-5.029-2.163l.023-.427.37-6.883h5.029l.37,6.883.023.427a2.888,2.888,0,0,1-.785,2.163Zm7.021-.109a2.9,2.9,0,0,1-5.1-1.72l-.021-.393h0l-.393-7.248H26.4L27.54,10.6a2.89,2.89,0,0,1-.652,2.342Zm7-.5a2.825,2.825,0,0,1-5.115-1.15L27.522,3.577h5L34.292,10.1a2.82,2.82,0,0,1-.4,2.342ZM3.107,1.109H32.395V2.467H3.107ZM1.21,10.1,2.975,3.577h5L7.206,8.331l-.34,2.09h0l-.141.866A2.825,2.825,0,1,1,1.21,10.1Z",
    transform: "translate(0)",
    fill: "#06233d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65343",
    "data-name": "Path 65343",
    d: "M34.946,37.33H33.5V19.414a.555.555,0,1,0-1.109,0V37.33h-1.86v-13.5a.555.555,0,0,0-.555-.555H22.79a.555.555,0,0,0-.555.555v13.5H3.106V19.42A.555.555,0,1,0,2,19.42V37.33H.555A.555.555,0,0,0,0,37.885v2.492a.555.555,0,0,0,.555.555H34.946a.555.555,0,0,0,.555-.555V37.885A.555.555,0,0,0,34.946,37.33Zm-11.6-12.947h6.08V37.33h-6.08Zm11.047,15.44H1.109V38.44H34.391Z",
    transform: "translate(0 -5.432)",
    fill: "#06233d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.73ffa0ae0013c7bb8679c014ee299e1a.svg";
export { ForwardRef as ReactComponent };